import type { ThemeOptions } from "@mui/material";

declare module "@mui/material/styles" {
	interface Palette {
		mono: Palette["primary"];
	}

	interface PaletteOptions {
		mono?: PaletteOptions["primary"];
	}
}

const MONO_THEME_DEFINITION: ThemeOptions = {
	components: {
		MuiButton: {
			variants: [
				{
					props: { variant: "contained", color: "mono" },
					style: ({ theme }) => ({ color: theme.palette.mono.contrastText }),
				},
			],
		},
		MuiToggleButton: {
			variants: [
				{
					props: { color: "mono" },
					style: ({ theme }) => ({
						transition: "all 0.2s linear",
						color: theme.palette.mono.main,
						background: "transparent",
						border: `1px solid ${theme.palette.mono.light}`,
						"&:hover": {
							color: theme.palette.mono.dark,
							background: "transparent",
							border: `1px solid ${theme.palette.mono.dark}`,
						},
						"&.Mui-selected": {
							color: theme.palette.mono.contrastText,
							backgroundColor: theme.palette.mono.dark,
							border: `1px solid ${theme.palette.mono.dark}`,
							"&:hover": {
								color: theme.palette.mono.contrastText,
								background: theme.palette.mono.dark,
								border: `1px solid ${theme.palette.mono.dark}`,
							},
						},
					}),
				},
			],
		},
	},
};

export { MONO_THEME_DEFINITION };
